import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { http } from './http';

var BookingService = /*#__PURE__*/function () {
  function BookingService() {
    _classCallCheck(this, BookingService);
  }

  _createClass(BookingService, [{
    key: "getUserBookings",
    value: function () {
      var _getUserBookings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return http.get("/user/".concat(userId, "/bookings"));

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getUserBookings(_x) {
        return _getUserBookings.apply(this, arguments);
      }

      return getUserBookings;
    }()
  }, {
    key: "getCurrentUserSessionBookings",
    value: function () {
      var _getCurrentUserSessionBookings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(sessionId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return http.get("/session/".concat(sessionId, "/user-bookings"));

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getCurrentUserSessionBookings(_x2) {
        return _getCurrentUserSessionBookings.apply(this, arguments);
      }

      return getCurrentUserSessionBookings;
    }()
  }, {
    key: "getBookingById",
    value: function () {
      var _getBookingById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return http.get("/booking/".concat(id));

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", result.data);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getBookingById(_x3) {
        return _getBookingById.apply(this, arguments);
      }

      return getBookingById;
    }()
  }, {
    key: "cancelBooking",
    value: function () {
      var _cancelBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(serviceId, sessionId, bookingId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return http.put("/provider-service/".concat(serviceId, "/sessions/").concat(sessionId, "/bookings/").concat(bookingId), {
                  status: 'cancelled',
                  attendees: 0,
                  bookingId: bookingId
                });

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", result.data);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function cancelBooking(_x4, _x5, _x6) {
        return _cancelBooking.apply(this, arguments);
      }

      return cancelBooking;
    }()
  }, {
    key: "createBooking",
    value: function () {
      var _createBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
        var serviceId, sessionId, orderId, attendees, stripeToken, receiveServiceEmails, result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                serviceId = payload.serviceId, sessionId = payload.sessionId, orderId = payload.orderId, attendees = payload.attendees, stripeToken = payload.stripeToken, receiveServiceEmails = payload.receiveServiceEmails;
                _context5.next = 3;
                return http.post("/provider-service/".concat(serviceId, "/sessions/").concat(sessionId, "/bookings"), {
                  attendees: attendees,
                  sessionId: sessionId,
                  orderId: orderId,
                  stripeToken: stripeToken,
                  receiveServiceEmails: receiveServiceEmails
                });

              case 3:
                result = _context5.sent;
                return _context5.abrupt("return", result.data);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function createBooking(_x7) {
        return _createBooking.apply(this, arguments);
      }

      return createBooking;
    }()
  }]);

  return BookingService;
}();

var bookingService = new BookingService();
export default bookingService;